import { POSAP_STATUS_READY_TO_SEND } from "../constants";
import { store } from "../store";
import { listExtToExport } from "../store/actions/ExtControlActions";
import {
  getProductionOrderSap,
  filterProductionOrderSap,
  updateProductionOrderSap,
  notifyOrder,
  listProductionOrderSapToExport,
} from "../store/actions/ProductionOrderSapActions";

/**
 * * List production order sap
 */
export const listFilterProductionOrderSap = async (filter) => {
  const result = await store.dispatch(filterProductionOrderSap(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const getDetail = async (uuid) => {
  const result = await store.dispatch(getProductionOrderSap(uuid));
  if (result?.payload?.data) {
    return result.payload;
  }

  return null;
};

export const addExtraInfoProductionOrderSap = async (uuid, values) => {
  const obj = { hourMen: values.hourMen };
  if (values.stopTime && values.stopTime >= 0) {
    obj.stopTime = values.stopTime;
  }
  const result = await store.dispatch(updateProductionOrderSap([uuid], obj));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const addExtraInfoAndFinishProductionOrderSap = async (uuid, values) => {
  const obj = {
    hourMen: values.hourMen,
    status: POSAP_STATUS_READY_TO_SEND.code,
  };
  if (values.stopTime && values.stopTime >= 0) {
    obj.stopTime = values.stopTime;
  }
  const result = await store.dispatch(updateProductionOrderSap(uuid, obj));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const notify = async (uuid) => {
  const result = await store.dispatch(notifyOrder([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const listToExport = async (filter) => {
  const result = await store.dispatch(listProductionOrderSapToExport(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};
